<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>博世柴油系统服务网络</span>提供专业服务</h1>
    <p>博世Bosch在全球有3,000多加柴油维修网络，是柴油引擎与零件维修的专业首选</p>
  </div>
  <app-scroll-spy-nav [sections]="[
  { id: 'bdx-1', label: '档案和维修' },
  { id: 'bdx-2', label: '博世柴油系统服务' },
  { id: 'bdx-3', label: '提供的服务' }]">
  </app-scroll-spy-nav>
  <section id="bdx-1" class="equipment-content">
    <div class="business-content">
      <div class="business-left">
        <img src="assets/official-website/bdx-1.png" alt="bdx-1">
      </div>
      <div class="business-right">
        <h1>博世柴油维修网络</h1>
        <p>
          自1927年世界上首次批量生产的直列式喷油泵标志着博世公司开始生产柴油喷油系统以来，
          博世公司一直处于柴油喷油系统技术的领先地位。1997年，博世公司开始批量生产柴油共轨系统，
          并广泛应用到小轿车、客车、轻型商用车、重型机动车、机车和轮船等领域。车辆、发动机装备柴油喷射系统日益增长，
          大量的新型高压柴油系统应用提高了诊断维修的复杂性。因此维修现代柴油系统需要高品质的测试设备、专业的服务人员、
          高精度的专用工具和高度清洁的维修车间。而与之相应的，博世柴油服务网络也发展的愈加完善。
          博世柴油系统服务网络成员作为博世在柴油维修领域最重要的合作伙伴，既能提供柴油系统的故障诊断，
          又能全面提供专业的核心部件维修，是博世的柴油系统维修专家。至2024年底，
          博世在中国大陆范围内已建立了26个博世柴油系统服务中心（BDC），以及
          268个博世柴油系统服务站（BDS ）。
        </p>
      </div>
    </div>
  </section>
  <section id="bdx-2" class="equipment-content">
    <div class="business-content">
      <div class="business-right mx:hidden">
        <img src="assets/official-website/bdx-2.png" alt="bdx-1">
      </div>
      <div class="business-left">
        <h1><span style="display: block;">博世柴油系统服务中心（BDC）</span></h1>
        <p>
          提供全系列的柴油喷射系统的诊断和维修，
          是博世柴油系统服务网络的最高级别。
        </p>
        <p><strong>博世柴油系统服务中心具备：</strong></p>
        <ul class="detail-list">
          <li>
            符合资格并定期受训的柴油系统技术人员
          </li>
          <li>
            全系列的高品质的诊断及测试设备
          </li>
          <li>
            最先进的柴油系统维修车间
          </li>
          <li>
            高精度的维修专用工具
          </li>
          <li>
            博世原厂配件
          </li>
          <li>
            新旧部件交换所需库存
          </li>
          <li>
            博世保修检测授权(部分)
          </li>
          <li>
            通过博世定期质量审核
          </li>
        </ul>
      </div>
      <div class="business-right sm:hidden">
        <img src="assets/official-website/bdx-2.png" alt="bdx-1">
      </div>
    </div>
    <div class="business-content">
      <div class="business-left">
        <img src="assets/official-website/bdx-3.png" alt="bdx-1">
      </div>
      <div class="business-right">
        <h1><span style="display: block;">博世柴油系统服务站（BDS）</span>
        </h1>
        <p>
          是博世柴油系统服务网络的重要组成部分。
        </p>
        <p><strong>博世柴油系统服务站具备：</strong></p>
        <ul class="detail-list">
          <li>
            符合资格并定期受训的柴油系统技术人员
          </li>
          <li>
            高品质的诊断及测试设备
          </li>
          <li>
            高精度的维修专用工具
          </li>
          <li>
            博世原厂配件
          </li>
          <li>
            博世保修检测授权(部分)
          </li>
          <li>
            通过博世定期质量审核
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section id="bdx-3" class="equipment-content">
    <div class="services-wrapper">
      <h2>我们为您提供的内容</h2>
      <p class="subtitle">
        成为博世授权维修厂的一员后，您的维修厂将获得由您在您的区域内提供可靠、出色的维修体验。
      </p>
    
      <div class="cards-container">
        <div class="card" *ngFor="let service of services">
          <img [src]="service.icon" alt="icon" />
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </div>
      </div>
    </div>
  </section>
</div>